// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { intlShape, defineMessages } from 'react-intl';
import { Helmet } from 'react-helmet';
import queryString from 'query-string';
import { Base64 } from 'js-base64';
import LoginForm from './LoginForm/LoginForm';

import style from './LoginPage.scss';

import type { Language } from '../../../../entities/language';
import type { HTTPError } from '../../../../error/index';
import type { Location } from '../../../../router';
import type { LocaleState } from '../../../locale/duck';

type Props = {
  +fbLogin: (country: ?string, language: Language, token: string,
             email?: string, redirectTo?: string) => void;
  +login: (email: string, password: string) => void;
  +logout: () => void;
  +isAuthing?: boolean;
  +authError?: HTTPError;
  +authenticated: boolean;
  +location: Location;
  +handleOpenSentForgotPasswordModal: () => void;
  +locale: LocaleState;
};

const messages = defineMessages({
  title: {
    id: 'auth.document.title',
  },
  description: {
    id: 'auth.document.description',
  }
});

const DEFAULT_REDIRECT_TO = '/';

export default class LoginPage extends Component<Props, void> {
  render() {
    const {
      location, authenticated, login, fbLogin,
      logout, isAuthing, authError, handleOpenSentForgotPasswordModal, locale,
    } = this.props;
    const parsedQuery = queryString.parse(location.search);
    const redirectTo = parsedQuery && parsedQuery.redirect ? Base64.decode(parsedQuery.redirect) : '';
    return [
      <Helmet key="helmet">
        <title>{this.context.intl.formatMessage(messages.title)}</title>
        <meta name="description" content={this.context.intl.formatMessage(messages.description)}/>
      </Helmet>,
      <section key="loginPageWrap"
               className={style.loginPageWrap}>
        <article className={style.loginWrap}>
          <LoginForm fbLogin={fbLogin}
                     login={login}
                     logout={logout}
                     isAuthing={isAuthing}
                     authError={authError}
                     locale={locale}
                     handleOpenSentForgotPasswordModal={handleOpenSentForgotPasswordModal}
                     redirectTo={redirectTo || DEFAULT_REDIRECT_TO}
                     authenticated={authenticated}
          />
        </article>
      </section>
    ];
  }
};

LoginPage.propTypes = {
  login: PropTypes.func.isRequired,
  fbLogin: PropTypes.func.isRequired,
  logout: PropTypes.func.isRequired,
  isAuthing: PropTypes.bool,
  authError: PropTypes.object,
  authenticated: PropTypes.bool,
  location: PropTypes.object.isRequired,
  handleOpenSentForgotPasswordModal: PropTypes.func.isRequired,
  locale: PropTypes.object,
};

LoginPage.contextTypes = {
  intl: intlShape,
};



// WEBPACK FOOTER //
// ./src/modules/auth/components/Login/LoginPage.jsx